/* unplugin-vue-components disabled */import { render } from "./ResultRightSide.vue?vue&type=template&id=792715a0&scoped=true"
const script = {}

import "./ResultRightSide.vue?vue&type=style&index=0&id=792715a0&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792715a0"]])

export default __exports__